




















































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import FrekuensiNadi from "@/components/pemeriksaan/assesmen/FrekuensiNadi.vue";
import FrekuensiNafas from "@/components/pemeriksaan/assesmen/FrekuensiNafas.vue";
import SaturasiOksigen from "@/components/pemeriksaan/assesmen/SaturasiOksigen.vue";
import SuhuBadan from "@/components/pemeriksaan/assesmen/SuhuBadan.vue";
import TekananDarah from "@/components/pemeriksaan/assesmen/TekananDarahNew.vue";
import { Tensi, TTV } from "@/types/asesmen";

@Component({
  components: {
    TekananDarah,
    FrekuensiNadi,
    FrekuensiNafas,
    SuhuBadan,
    SaturasiOksigen
  }
})
export default class TandaVital extends Vue {
  @Prop() readonly value;
  @Prop({
    default: ["sistole", "diastole", "nadi", "nafas", "suhu", "saturasiO2"]
  })
  params;

  sistole = null;
  diastole = null;
  nadi = null;
  nafas = null;
  suhu = null;
  saturasiO2 = null;
  keadaanUmum = null;
  kesadaran = null;

  set tensi(val: Tensi) {
    this.sistole = val.sistole;
    this.diastole = val.diastole;
  }

  get tensi(): Tensi {
    return {
      sistole: this.sistole,
      diastole: this.diastole
    };
  }

  get ttv(): TTV {
    return {
      sistole: this.sistole,
      diastole: this.diastole,
      nadi: this.nadi,
      nafas: this.nafas,
      suhu: this.suhu,
      saturasiO2: this.saturasiO2,
      keadaanUmum: this.params.includes("keadaanUmum")
        ? this.keadaanUmum
        : undefined,
      kesadaran: this.params.includes("kesadaran") ? this.kesadaran : undefined
    };
  }

  set ttv(val: TTV) {
    this.setTensi({
      sistole: val.sistole,
      diastole: val.diastole
    });
    this.setFrekNadi(val.nadi);
    this.setFrekNafas(val.nafas);
    this.setSuhu(val.suhu);
    this.setSaturasiO2(val.saturasiO2);
    // this.keadaanUmum = val.keadaanUmum;
    this.setKeadaanUmum(val.keadaanUmum);
    this.setKesadaran(val.kesadaran);
  }

  setTensi(val: Tensi) {
    this.tensi = {
      sistole: !val.sistole && val.sistole != 0 ? null : Number(val.sistole),
      diastole: !val.diastole && val.diastole != 0 ? null : Number(val.diastole)
    };
  }

  setFrekNadi(val) {
    this.nadi = !val && val != 0 ? null : Number(val);
  }

  setFrekNafas(val) {
    this.nafas = !val && val != 0 ? null : Number(val);
  }

  setSuhu(val) {
    this.suhu = !val && val != 0 ? null : Number(val);
  }

  setSaturasiO2(val) {
    this.saturasiO2 = !val && val != 0 ? null : Number(val);
  }

  setKeadaanUmum(val) {
    this.keadaanUmum = !val && val != 0 ? null : val;
  }

  setKesadaran(val) {
    this.kesadaran = !val && val != 0 ? null : val;
  }

  @Watch("ttv", { deep: true })
  changeTtv(val: TTV) {
    console.log("changeTtv", val);
    this.$emit("setValue", val);
  }

  @Watch("value", { deep: true })
  changeValue(val: TTV) {
    console.log("changeValue", val);
    this.ttv = val;
  }
}
